import ErrorICon from "assets/images/sales/Vectorerror.svg";
import { useFormik } from "formik";
import moment from "moment";
import { Calendar } from "primereact/calendar";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { updateInceptionDate } from "redux/actions/motorActions";
import Calenderwrapper from "./style";
import CalendarIcon from "assets/images/icons/components/CalendarIcon";

const Calender = (props) => {
  const { t, i18n } = useTranslation();
  const minDate = moment().add(1, 'day').toDate();
  const currentLanguageCode = i18n?.language || "en";
  const dispatch = useDispatch();
  const showRTL = currentLanguageCode === "ar";
  const [inceptionDateValue, setInceptionDateValue] = useState(null);
  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 45);


  useEffect(() => {
    if (inceptionDateValue) {
      const formattedDate = moment(inceptionDateValue).format("DD-MM-YYYY");
      dispatch(updateInceptionDate(formattedDate));
    }
  }, [inceptionDateValue]);

  return (
    <Calenderwrapper>
      <div className="form_wrapper w-100">
        <div className="p-fluid  cal-inp w-100">
          <div className="field ">
            <span
              className={
                "p-float-label newclass p-input-icon-left isEnglish" + (showRTL ? " arabicar" : "")
              }
            >
              <CalendarIcon className={showRTL ? " arabicimg" : ""} />
              <Calendar
                showIcon
                minDate={new Date(minDate)}
                maxDate={maxDate}
                className={showRTL ? "arabictext mb-2" : "mb-2  "}
                iconPos={"left"}
                value={inceptionDateValue}
                onSelect={(e) => setInceptionDateValue(e.value)}
                dateFormat="dd/mm/yy"
              />
              <label htmlFor="" className={showRTL ? " arabiclabel" : ""}>
                {" "}
                {t("POLICY.POLICY_DATE")}{" "}
              </label>
            </span>
            {!inceptionDateValue && (
              <span style={{ color: "red", marginTop: "5px" }}>{t("SALES.pole-8")}</span>
            )}
          </div>
        </div>
      </div>
    </Calenderwrapper>
  );
};

export default Calender;
